export const environment = {
  production: true,
  apiUrl: 'https://www.wuerzburger.com/webservice/trcoreservice',
  apiReporting: true,
  legacyRechnerBaseURL: 'https://rechner.travelsecure.de/tsrechner/',
  designerUrl: '',
  externalChange: false,
};
export const DebugMethod = (
  _target: Object,
  _propKey: string,
  desc: PropertyDescriptor
): void => {};
